import { Box, Button, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import ListOperations from './ListOperations'
import CreateEvent from '../CreateEvent'
import { makePutRequest } from 'utils/api'
import { isEmpty } from 'lodash'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import OpenAiTask from '../OpenAiTask'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export const MesTaches = ({
  CreateTacheModal,
  updateTodo = false,
  createTache,
  taskCat = '',
  typeFilter = '',
  projectTaskId = '',
  projectTaskName = '',
  listeTaskId = '',
  listeTaskName = '',
  Priorite = '',
  setPriorite,
  taskstatus = '',
  setStatus,
  updateTodoList,
}) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const [loading, setLoading] = useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedOperation, setSelectedOperation] = useState({})
  const [planifier, setPlanifier] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedRowsData, setSelectedRowsData] = useState({})
  const [event, setEvent] = useState({})
  const [showTaskModel, setShowTaskModel] = useState(false)
  const [tasklist, setTasklist] = useState([])

  useEffect(() => {
    fetchOperations()
    // taskstatus ajouté : un filtre SmartFeed « Terminées » (Statut=Fait) ne
    // change QUE taskstatus ; sans cette dépendance la liste ne se rafraîchit
    // pas quand on arrive depuis une carte du fil sans remontage du composant.
  }, [createTache, taskCat, typeFilter, projectTaskId, listeTaskId, taskstatus])

  const fetchOperations = async (pagination = '') => {
    // console.log(Priorite)
    // LAP — `TypeTache` filtre la liste par type (livrable/habitude/competence/kpi)
    let url = `${urls.taskOperations}?task=${taskCat}&TypeTache=${typeFilter}&ProjectId=${projectTaskId}&ListeId=${listeTaskId}&Priorite=${Priorite}&Statut=${taskstatus}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      if (taskCat === 'cat1') updateTodoList('cat1', response.data.results)
      if (taskCat === 'cat2') updateTodoList('cat2', response.data.results)
      if (taskCat === 'cat3') updateTodoList('cat3', response.data.results)
      if (taskCat === 'cat4') updateTodoList('cat4', response.data.results)
      if (taskCat === 'cat5') updateTodoList('cat5', response.data.results)
      setOperations({ ...response.data })
    }
  }

  const handelPlanifier = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      setPlanifier(true)
    }
  }
  const faitBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => {
        if (selectedRows.indexOf(v.id) !== -1) {
          v.Statut = 'Fait'
        }
        return v
      })
      setOperations({
        ...operations,
        results: filteredOperations,
      })
      const response = await makePostRequest(
        urls.faitBulkTachesOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Update Successfully')
        document.querySelector('[aria-label="Unselect all rows"]')?.click()
        updateTodo()
      }
    }
  }
  const enCoursBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => {
        if (selectedRows.indexOf(v.id) !== -1) {
          v.Statut = 'En-Cours'
        }
        return v
      })
      setOperations({
        ...operations,
        results: filteredOperations,
      })
      const response = await makePostRequest(
        urls.enCoursBulkTachesOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Update Successfully')
        document.querySelector('[aria-label="Unselect all rows"]')?.click()
        updateTodo()
      }
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkTachesOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
        updateTodo()
      }
    }
  }
  const toggleModal = () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      // console.log(selectedRows)
      const row = operations.results.filter((e) => e.id === selectedRows[0])
      // console.log(row)
      if (row.length > 0) setSelectedRowsData(row[0])
      setShowModal(!showModal)
    }
  }
  useEffect(() => {
    if (!isEmpty(event)) {
      insertEvent()
    }
    console.log(event)
  }, [event])
  const insertEvent = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const payload = {
        EventData: event,
      }
      const response = await makePutRequest(
        urls.taskOperations + selectedRows[0] + '/',
        payload,
        {},
        true,
      )
      if (response.status === 200) {
        setEvent({})
        updateTodo()
      }
    }
  }
  // Reçoit la liste validée depuis la modale OpenAiTask (le state local
  // `tasklist` sert de repli). forEach(async) ne bloquait pas : updateTodo()
  // partait avant les POST et les erreurs 400 passaient inaperçues.
  const submitTaskList = async (list = tasklist) => {
    if (list.length > 0) {
      const responses = await Promise.all(
        list.map((el) =>
          makePostRequest(
            urls.taskOperations,
            {
              Nom: el.Name,
              Descriptions: el.Description,
              DateLimite: el.Date_limite,
              Priorite: el.Urgence,
              Categorie: el.cat_id,
              Couts: el.Cost_estime,
              ProjectId: projectTaskId,
            },
            {},
            true,
          ),
        ),
      )
      const failed = responses.filter((r) => r.status !== 201).length
      if (failed > 0) {
        alert(t('mesToDo.taskSaveError', { failed, total: list.length }))
      }
      updateTodo()
    }
  }
  const handleOpenAi = async () => {
    // return
    setLoading(true)
    const payload = {
      pid: projectTaskId,
    }
    const response = await makePostRequest('/api/mestodo/genrate-openai-detail/', payload, {}, true)
    if (response.status === 200) {
      setLoading(false)
      setShowTaskModel(true)
      setTasklist(response.data)
    } else {
      setTasklist([])
      setLoading(false)
      alert(t('mesToDo.openAiError'))
    }
  }
  return (
    <>
      {showModal && (
        <CreateEvent
          isOpen={showModal}
          toggleModal={toggleModal}
          setEvent={setEvent}
          row={selectedRowsData}
        />
      )}
      {showTaskModel && (
        <OpenAiTask
          setShowTaskModel={setShowTaskModel}
          tasklist={tasklist}
          setTasklist={setTasklist}
          submitTaskList={submitTaskList}
        />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            {isMobile ? (
              <Box color={'white'} display={'flex'} gap={2}>
                <AddCircleIcon
                  onClick={() => {
                    CreateTacheModal()
                    setPriorite('')
                    setStatus('')
                  }}
                />
                <RemoveCircleIcon onClick={deleteBulkOperations} />
                <EventAvailableIcon onClick={toggleModal} />

                <KeyboardDoubleArrowRightIcon onClick={enCoursBulkOperations} />
                <CheckCircleIcon sx={{ color: 'green' }} onClick={faitBulkOperations} />
              </Box>
            ) : (
              <>
                {projectTaskId && (
                  <Button
                    sx={{ ml: 2 }}
                    title={t('mesToDo.openAiTitle')}
                    onClick={handleOpenAi}
                    loading={loading}
                    disabled={loading}
                    loadingPosition="start"
                  >
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <img src="/openai-white.svg" style={{ height: 30 }} alt="oai" />
                    )}
                  </Button>
                )}
                <CustomButton sx={{ color: 'white' }} onClick={toggleModal}>
                  {t('mesToDo.schedule')}
                </CustomButton>
                <CustomButton
                  onClick={() => {
                    CreateTacheModal()
                    setPriorite('')
                    setStatus('')
                  }}
                >
                  {t('mesToDo.add')}
                </CustomButton>
                <CustomButton onClick={faitBulkOperations}>{t('mesToDo.markAsDone')}</CustomButton>
                <CustomButton onClick={enCoursBulkOperations}>{t('mesToDo.markAsOngoing')}</CustomButton>
                <CustomButton onClick={deleteBulkOperations}>{t('mesToDo.delete')}</CustomButton>
              </>
            )}
          </Box>
        </Box>
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
          projectTaskId={projectTaskId}
          projectTaskName={projectTaskName}
          listeTaskId={listeTaskId}
          listeTaskName={listeTaskName}
        />
      </Container>
    </>
  )
}
